import { CanvasTexture, Vector3 } from '@anov/3d-core'

export interface TextOption {
  value?: string
  fontSize?: number
  color?: string
  fontWeight?: string
}
//  获取文字的canvas
export const createTextCanvas = (option: TextOption) => {
  const { value: text, fontSize, color, fontWeight } = option || {}

  const pixelRatio = 1// window.devicePixelRatio || 1
  const tempCanvas = document.createElement('canvas')
  const ctx = tempCanvas.getContext('2d')!
  ctx.font = `${fontWeight} ${fontSize * pixelRatio}px Arial`

  const textWidth = Math.ceil(ctx.measureText(text).width)
  const textHeight = Math.ceil(fontSize * pixelRatio * 1.1)

  const canvas = document.createElement('canvas')
  canvas.width = textWidth
  canvas.height = textHeight
  const context = canvas.getContext('2d')!
  context.fillStyle = color
  context.font = ctx.font
  context.textAlign = 'center'
  context.textBaseline = 'middle'
  context.fillText(text, textWidth / 2, textHeight / 2)

  return { width: textWidth, height: textHeight, texture: new CanvasTexture(canvas) }
}

export const lookAtOnYAxis = (mesh, targetPosition) => {
  if (!mesh || !targetPosition || !mesh.position || !mesh.rotation)
    return
  const direction = new Vector3().subVectors(targetPosition, mesh.position)
  direction.y = 0
  direction.normalize()
  // 修正水平朝向计算：绕 Y 轴朝向相机
  // 标准做法：yaw = atan2(dx, dz)
  const yaw = Math.atan2(direction.x, direction.z)
  mesh.rotation.y = yaw
}
